/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevokeInvitationRequest
 */
export interface RevokeInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof RevokeInvitationRequest
     */
    inviteeEmailAddress: string;
}

/**
 * Check if a given object implements the RevokeInvitationRequest interface.
 */
export function instanceOfRevokeInvitationRequest(value: object): value is RevokeInvitationRequest {
    if (!('inviteeEmailAddress' in value) || value['inviteeEmailAddress'] === undefined) return false;
    return true;
}

export function RevokeInvitationRequestFromJSON(json: any): RevokeInvitationRequest {
    return RevokeInvitationRequestFromJSONTyped(json, false);
}

export function RevokeInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevokeInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteeEmailAddress': json['inviteeEmailAddress'],
    };
}

  export function RevokeInvitationRequestToJSON(json: any): RevokeInvitationRequest {
      return RevokeInvitationRequestToJSONTyped(json, false);
  }

  export function RevokeInvitationRequestToJSONTyped(value?: RevokeInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteeEmailAddress': value['inviteeEmailAddress'],
    };
}

